import React from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import useFormStore from "../state/useFormStore";
import { formatCurrency } from '../utils/utils';
import OfertasImg from '../assets/money.json';
import { Button } from '@mui/material';

const HighlightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const AnimationWrapper = styled.div`
  width: 200px;
  margin: 12px 0;
`;

const HighlightBox = styled.div`
  background: #f8f8f8;
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  width: 90%;
  max-width: 500px;
  text-align: center;
`;

const AmountText = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #000;
  margin: 16px 0;
`;

const InstallmentsText = styled.div`
  font-size: 20px;
  color: #666;
  margin: 8px 0;
`;

const Disclaimer = styled.p`
  font-size: 12px;
  color: #666;
  margin: 16px 0;
`;

interface PreOffer {
  maxAmount: number;
  minAmount: number;
  installments: number;
}

const PreOfferAvailableAmounts: React.FC = () => {
  const navigate = useNavigate();
  const { preOffers, hash } = useFormStore();
  
  const maxAmount = preOffers ? Math.max(...(preOffers as PreOffer[]).map(offer => offer.maxAmount)) : 0;
  const maxInstallments = preOffers ? Math.max(...(preOffers as PreOffer[]).map(offer => offer.installments)) : 0;

  const handleContinue = () => {
    navigate(`/${hash}/ingresos`);
  };

  return (
    <HighlightContainer>
      <AnimationWrapper>
        <Lottie animationData={OfertasImg} loop={true} />
      </AnimationWrapper>

      <HighlightBox>
        <div>Podemos ofrecerte un préstamo por</div>
        <AmountText>{formatCurrency(maxAmount)}</AmountText>
        <InstallmentsText>
          en {maxInstallments} {maxInstallments === 1 ? 'mes' : 'meses'}
        </InstallmentsText>
      </HighlightBox>

      <Button
        variant="contained"
        onClick={handleContinue}
        style={{
          backgroundColor: "#FFF200",
          color: "black",
          fontWeight: 600,
          boxShadow: "none",
          borderRadius: 50,
          padding: "12px 40px",
          textTransform: "none",
          fontSize: 16,
          width: '90%',
          maxWidth: '400px'
        }}
      >
        Continuar
      </Button>

      <Disclaimer>
        Pre-oferta sujeta a calificación crediticia final
      </Disclaimer>
    </HighlightContainer>
  );
};

export default PreOfferAvailableAmounts; 